import { Box, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import React from "react";

interface MapZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
}

const MapZoomControls: React.FC<MapZoomControlsProps> = ({
  onZoomIn,
  onZoomOut,
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 16,
        right: 16,
        display: "flex",
        flexDirection: "column",
        gap: 1,
        zIndex: 1,
      }}
    >
      <IconButton
        onClick={onZoomIn}
        sx={{
          backgroundColor: "white",
          "&:hover": { backgroundColor: "#f0f0f0" },
          boxShadow: 1,
        }}
      >
        <AddIcon />
      </IconButton>
      <IconButton
        onClick={onZoomOut}
        sx={{
          backgroundColor: "white",
          "&:hover": { backgroundColor: "#f0f0f0" },
          boxShadow: 1,
        }}
      >
        <RemoveIcon />
      </IconButton>
    </Box>
  );
};

export default MapZoomControls;
